import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React from 'react';
import { ICON_SIZE } from "../../icons";
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ButtonIcon, ButtonLoader, ButtonText } from "../elements";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledButtonContentIcon = styled(ButtonIcon).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isTextVisuallyHidden'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var isTextVisuallyHidden = _ref.isTextVisuallyHidden;
  return !isTextVisuallyHidden && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      margin-right: ", ";\n    "])), function (_ref2) {
    var theme = _ref2.theme;
    return theme.size.spacing.small.value;
  });
});

var ButtonContent = function ButtonContent(_ref3) {
  var dataTestId = _ref3.dataTestId,
      hideText = _ref3.hideText,
      icon = _ref3.icon,
      iconClassName = _ref3.iconClassName,
      iconSize = _ref3.iconSize,
      isLoading = _ref3.isLoading,
      loaderText = _ref3.loaderText,
      text = _ref3.text;

  if (isLoading) {
    return /*#__PURE__*/_jsx(ButtonLoader, {
      label: loaderText,
      "data-testid": dataTestId ? "".concat(dataTestId, "-loader") : undefined
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!!icon && /*#__PURE__*/_jsx(StyledButtonContentIcon, {
      "data-testid": dataTestId ? "".concat(dataTestId, "-icon") : undefined,
      className: iconClassName,
      iconSize: iconSize,
      isTextVisuallyHidden: hideText,
      children: icon
    }), !!text && /*#__PURE__*/_jsx(ButtonText, {
      "data-testid": dataTestId ? "".concat(dataTestId, "-text") : undefined,
      isHidden: hideText,
      children: text
    })]
  });
};

ButtonContent.propTypes = {
  /** Id value used for testing */
  dataTestId: PropTypes.string,

  /** If true, will visually hide text */
  hideText: PropTypes.bool,

  /** If not loading, will render specified icon before text. Use icon component from the library */
  icon: PropTypes.node,

  /** Adds new class for icon element */
  iconClassName: PropTypes.string,

  /** Will set size of the icon */
  iconSize: PropTypes.oneOf(Object.values(ICON_SIZE)),

  /** If true, will display loader */
  isLoading: PropTypes.bool,

  /** Loader text which will be read for screen reader users */
  loaderText: PropTypes.node,

  /** Will display text inside button */
  text: PropTypes.node.isRequired
};
ButtonContent.defaultProps = {
  dataTestId: undefined,
  hideText: false,
  icon: undefined,
  iconClassName: '',
  iconSize: ICON_SIZE.DEFAULT,
  isLoading: false,
  loaderText: 'Loading...'
};
export { ButtonContent, StyledButtonContentIcon };